import {
  useMutation,
  useSuspenseQuery,
} from "@tanstack/react-query";
import {
  createFileRoute,
  Outlet,
  useNavigate,
} from "@tanstack/react-router";

import { useTRPC } from "@/infrastructure/trpc/react";

export const Route = createFileRoute(
  "/app/speech-agent/agents"
)({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(
      context.trpc.speechAgent.agents.list.queryOptions()
    );
  },
  component: AgentsLayout,
});

function AgentsLayout() {
  return <Outlet />;
}

export function AgentsListPage() {
  const trpc = useTRPC();
  const navigate = useNavigate();
  const { data: agents, refetch } = useSuspenseQuery(
    trpc.speechAgent.agents.list.queryOptions()
  );
  const seedDefaults = useMutation(
    trpc.speechAgent.agents.seedDefaults.mutationOptions({
      onSuccess: () => {
        void refetch();
      },
    })
  );

  return (
    <section className="page" id="page-agents">
      <div className="card list-card">
        <div className="card-head">
          <p className="kicker">— Knihovna</p>
          <h2 className="card-title">Tvoji agenti</h2>
          <div className="card-actions">
            <button
              type="button"
              className="primary-btn"
              onClick={() =>
                void navigate({
                  to: "/app/speech-agent/agents/new",
                })
              }
            >
              Nový agent
            </button>
            <button
              type="button"
              className="ghost-btn"
              onClick={() => seedDefaults.mutate()}
              disabled={seedDefaults.isPending}
            >
              {seedDefaults.isPending
                ? "Sázím…"
                : "Obnovit výchozí"}
            </button>
          </div>
        </div>
        {agents.length === 0 ? (
          <p className="status">
            Žádní agenti. Klikni na{" "}
            <strong>Nový agent</strong> nebo{" "}
            <strong>Obnovit výchozí</strong>.
          </p>
        ) : (
          <ul className="list">
            {agents.map((a) => (
              <li key={a.slug} className="historie-item">
                <div className="historie-item-main">
                  <p className="historie-item-title">
                    {a.name}
                  </p>
                  <p className="historie-item-meta">
                    {a.slug} · {a.language} · {a.voiceName}
                  </p>
                </div>
                <div className="item-actions">
                  <button
                    type="button"
                    onClick={() =>
                      void navigate({
                        to: "/app/speech-agent/agents/$slug",
                        params: { slug: a.slug },
                      })
                    }
                  >
                    Upravit
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
